import { useTranslation } from 'react-i18next'

import { getOutcomeBadgeAppearance } from '../utils/getOutcomeBadgeAppearance'

import { RoleCategoryBadgesProps } from './RoleCategoryBadges.types'
import { RoleCategory, RoleCategoryVerdict, RoleCategoryVerdicts } from '@percent/admin-dashboard/api/types'
import { RoleCategoriesConfig } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { Badge, Flex } from '@percent/lemonade'

const getConfigVerdict = (
  category: RoleCategory,
  { accepted, rejected }: RoleCategoriesConfig
): RoleCategoryVerdict | undefined => {
  if (accepted.includes(category)) return 'accepted'

  if (rejected.includes(category)) return 'rejected'

  return undefined
}

const getVerdict = (
  category: RoleCategory,
  roleCategoriesConfig: RoleCategoriesConfig,
  verdicts?: RoleCategoryVerdicts | null
) => verdicts?.[category] ?? getConfigVerdict(category, roleCategoriesConfig)

export function RoleCategoryBadges({ categories, roleCategoriesConfig, verdicts }: Readonly<RoleCategoryBadgesProps>) {
  const { t } = useTranslation()

  return (
    <Flex gap={8} wrap="wrap" justify="flex-start">
      {[...new Set(categories)].map(category => (
        <Badge
          key={category}
          testId={`role-category-${category}`}
          {...getOutcomeBadgeAppearance(getVerdict(category, roleCategoriesConfig, verdicts))}
        >
          {t(`typography.roleCategory.${category}`, { defaultValue: category })}
        </Badge>
      ))}
    </Flex>
  )
}
